<app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent"  [isLogoutVisible]="isLogoutVisible"> </app-brand-header>

<main class="dsb-cv-container">

  <div class="dsb-cv-form">

    <div class="dsb-cv-title"><h3>{{promptTitle}}</h3></div>
    <div class="dsb-cv-prompt">{{prompt}}</div>
    <form #form role="form" [formGroup]="cvForm">
  
      <section>
  
        <ng-container *ngFor="let cvField of cvFields">
  
              <label for="cvField.key">{{cvField.label}}:</label>
              <input [id]="cvField.key" type="text"  pattern="{{cvField.pattern}}"
                  placeholder="{{cvField.placeholder}}" [formControlName]="cvField.key" />
              <div class="error-txt-msg" *ngIf="cvForm.controls[cvField.key].hasError('pattern')" style="color: red;">
                {{cvField.invalidFormatMsg}}
              </div>
  
        </ng-container>
  
      </section>
  
    </form>
  
    <div class="dsb-cv-footer">
      <div>
        <button type="button" class="dsb-cv-btn" (click)="onSubmit()">Log in</button>
      </div>
    </div>
  

  </div>

  <div *ngIf="showErrorMessage">
    <div class="alert alert-danger" role="alert">
        {{errorMessage}}
    </div>
  </div>

</main>

